export const SET_LOYALTY_POINTS = 'SET_LOYALTY_POINTS';
export const SET_LOYALTY_POINTS_ERROR = 'SET_LOYALTY_POINTS_ERROR';
export const LOYALTY_BADGES_FETCHING = 'LOYALTY_BADGES_FETCHING';
export const LOYALTY_BADGES_FETCH = 'LOYALTY_BADGES_FETCH';
export const LOYALTY_BADGES_FETCH_ERROR = 'LOYALTY_BADGES_FETCH_ERROR';
export const LOYALTY_TIERS_FETCHING = 'LOYALTY_TIERS_FETCHING';
export const LOYALTY_TIERS_FETCH = 'LOYALTY_TIERS_FETCH';
export const LOYALTY_TIERS_FETCH_ERROR = 'LOYALTY_TIERS_FETCH_ERROR';
export const LOYALTY_TASKS_FETCHING = 'LOYALTY_TASKS_FETCHING';
export const LOYALTY_TASKS_FETCH = 'LOYALTY_TASKS_FETCH';
export const LOYALTY_TASKS_FETCH_ERROR = 'LOYALTY_TASKS_FETCH_ERROR';
